import { SearchApiParams } from '@finxone-platform/shared/sys-config-types';

export class GetTeamMembers {
  static readonly type = '[TeamMembers] GetTeamMembers';
  constructor(public payload: SearchApiParams) {}
}
